import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Api_Url } from '../../config/config'
import axios from 'axios'
import { Button, Divider, Modal, Table } from 'antd'
import { ErrorToast, SuccessToast, UpdatedToast } from '../../views/ToastComponent'

function SaloonProfileDetails() {
    const { id } = useParams()

    const [singleData, setSingleData] = useState([])
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = React.useState(false);

    const getSingleUser = async () => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Salon/item/getsllsalonitembysalonid/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            setSingleData(response.data.data)
        } catch (error) {
            return error.message
        }
    }

    useEffect(() => {
        getSingleUser()
    }, [])

    const [salonData, setSalonData] = useState({
        salonId: id,
        name: "",
        footFall: 0,
        price: 0,
        serviceTime: 0,
        totalTimeConsumed: 0,
        grossIncome: 0,
        latitude: "",
        longitude: ""

    })

    useEffect(() => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {

                const { latitude, longitude } = position.coords;
                setSalonData({ ...salonData, latitude: latitude.toString(), longitude: longitude.toString() });
            });
        } else {
            console.log("Geolocation is not supported by this browser.");
        }
    }, [])

    const handleSubmit = async () => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Salon/item`, salonData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                SuccessToast("Added Successfully")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error.message
        }
    }


    const calculateMonthlyRevenue = () => {
        const result = salonData.serviceTime * salonData.footFall
        setSalonData(prev => ({
            ...prev,
            totalTimeConsumed: result
        }))
    };

    const calculatePerMonth = () => {
        const result = salonData.footFall * salonData.price
        setSalonData(prev => ({
            ...prev,
            grossIncome: result
        }))
    };

    // // //   React.useEffect(() => { fetchIncomeData(); fetchAreaType(); fetchCurentLocation(); }, []);

    React.useEffect(() => {
        calculateMonthlyRevenue();
    }, [salonData.serviceTime, salonData.footFall]);

    React.useEffect(() => {
        calculatePerMonth();
    }, [salonData.price, salonData.footFall]);

    //   saloon edit func



    const handleClick = async (id) => {
        try {
            const response = await axios.get(`${Api_Url}api/v1/Salon/item/${id}`, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }

            })
            setSalonData(response.data.data)
            setIsEditModalOpen(true)
        } catch (error) {
            return error.message
        }
    }


    //update Method

    const handleUpdate = async (id) => {
        try {
            const response = await axios.post(`${Api_Url}api/v1/Salon/item/${id}`, salonData, {
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
                }
            })
            if (response.data.succeeded) {
                UpdatedToast("Successfully Updated")
                handleCancel()
                getSingleUser()
            }
        } catch (error) {
            ErrorToast("Something went wrong")
            return error
        }
    }

    const columns = [
        {
            title: "Service",
            dataIndex: "name",
            // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
        },
        {
            title: "Foot fall",
            dataIndex: "footFall",
            // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
        },
        {
            title: "Price",
            dataIndex: "price",
            // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
        },
        {
            title: "Service Time",
            dataIndex: "serviceTime",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Total Time Consumed",
            dataIndex: "totalTimeConsumed",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: "Gross Income",
            dataIndex: "grossIncome",
            // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
        },
        {
            title: 'Edit',
            dataIndex: 'edit',
            // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
            render: (text, record) => (
                <div>
                    {text}
                    <Button
                        // className='btn btn-secondary'
                        type="primary"
                        onClick={() => handleClick(record.id)}
                        style={{ marginLeft: '10px' }}
                    >
                        <i class="fa-solid fa-pen-to-square"></i>
                    </Button>
                </div>
            ),
        },
        // {
        //     title: 'Delete',
        //     dataIndex: 'delete',
        //     // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
        //     render: (text, record) => (
        //         <div>
        //             {text}
        //             <Button
        //                 className='btn btn-danger'
        //                 type="primary"
        //                 // onClick={() => handleClick(record.id)}
        //                 style={{ marginLeft: '10px' }}
        //             >
        //                 <i class="fa-solid fa-trash"></i>
        //             </Button>
        //         </div>
        //     ),
        // },
    ];

    async function handleCancel() {
        setSalonData({
            ...salonData,
            salonId: id,
            name: "",
            footFall: 0,
            price: 0,
            serviceTime: 0,
            totalTimeConsumed: 0,
            grossIncome: 0,
        })
        setIsModalOpen(false);
        setIsEditModalOpen(false);
    }


    return (

        <>
            <div className="page-wrapper">
                <div className="content container-fluid">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">
                            <h3 className="mb-0">Saloon Assesment</h3>
                            <button className="btn btn-primary submit-btn mb-2" onClick={() => setIsModalOpen(true)}>Add Service</button>
                        </div>
                    </div>

                    <div className="row mt-4">
                        <div className="col-12 mx-auto">
                            <Table
                                className="table-striped"
                                style={{ overflowX: "auto" }}
                                columns={columns}
                                dataSource={singleData}
                                rowKey={(record) => record.id}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Modal
                title={<h4>salon Assesment</h4>}
                open={isModalOpen}
                onOk={() => setIsModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={handleSubmit}>Submit</button>

                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Create Service</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        service Name
                                    </label>
                                    <input className="form-control" type="text" placeholder="service Name" value={salonData.name} onChange={(e) => setSalonData({ ...salonData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Time IN minute:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Taking Time in minute" value={salonData.serviceTime} onChange={(e) => setSalonData({ ...salonData, serviceTime: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Foot Fall:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter Foot Fall" value={salonData.footFall} onChange={(e) => setSalonData({ ...salonData, footFall: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Price:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Price" value={salonData.price} onChange={(e) => setSalonData({ ...salonData, price: e.target.value })} />
                                </div>
                            </div>
                        </div>


                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Total Time Consumed: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {salonData.totalTimeConsumed.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Gross Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {salonData.grossIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>

            {/* Edit Modal */}
            <Modal
                title={<h4>salon Assesment</h4>}
                open={isEditModalOpen}
                onOk={() => setIsEditModalOpen(false)}
                onCancel={() => handleCancel()}
                footer={[
                    <div className='d-flex justify-content-between align-items-center'>
                        <button key="Cancel" className="btn btn-danger submit-btn" type="button" onClick={handleCancel}>Cancel</button>,
                        <button key="submit" className="btn btn-primary submit-btn" type="submit" onClick={() => handleUpdate(salonData.id)}>Update</button>
                    </div>
                ]}
                width={600}
                mask={false}
                maskClosable={false}
                closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
                <div className="modal-body mt-5">
                    <form>
                        <Divider>Create Service</Divider>
                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        service Name
                                    </label>
                                    <input className="form-control" type="text" placeholder="service Name" value={salonData.name} onChange={(e) => setSalonData({ ...salonData, name: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Time IN minute:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Taking Time in minute" value={salonData.serviceTime} onChange={(e) => setSalonData({ ...salonData, serviceTime: e.target.value })} />
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Foot Fall:
                                    </label>
                                    <input className="form-control" type="text" placeholder="Enter Foot Fall" value={salonData.footFall} onChange={(e) => setSalonData({ ...salonData, footFall: e.target.value })} />
                                </div>
                            </div>
                            <div className="col-sm-6">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">
                                        Price:
                                    </label>
                                    <input className="form-control" type="number" placeholder="Enter Price" value={salonData.price} onChange={(e) => setSalonData({ ...salonData, price: e.target.value })} />
                                </div>
                            </div>
                        </div>


                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Total Time Consumed: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {salonData.totalTimeConsumed.toFixed(2)}</span>
                            </div>
                        </div>

                        <div className="row my-3">
                            <div className="col-sm-12 d-flex align-items-center justify-content-between">
                                <p className="mb-0">Gross Income: </p>
                                <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">&#8377; {salonData.grossIncome.toFixed(2)}</span>
                            </div>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
}

export default SaloonProfileDetails
